import { EBuildersInfoActionTypes } from '../../actions/buildersInfo';
import { EFilterActionTypes } from '../../actions/filters';
import { TReduxActions } from '../../types/redux';
import { IFilters } from '../../types/filters';

export const filtersReducer = (state: IFilters = {}, action: TReduxActions) => {
  switch (action.type) {
    case EFilterActionTypes.SetAll:
      return {
        ...action.payload,
      };
    case EFilterActionTypes.SetRegion:
      return {
        ...state,
        location: action.payload,
        page: undefined,
      };
    case EFilterActionTypes.SetSortType:
      return {
        ...state,
        sort: action.payload,
        page: undefined,
      };
    case EFilterActionTypes.SetSearchText:
      return {
        ...state,
        searchText: action.payload,
        page: undefined,
      };
    case EFilterActionTypes.SetPage:
      return {
        ...state,
        page: action.payload,
      };
    case EBuildersInfoActionTypes.Success:
      return {
        ...state,
        page: action.payload.page,
      };

    default:
      return state;
  }
};
